import React, {useEffect, useState} from 'react'
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";
import ModalAttaches from "../../../../../components/modal/modal-attaches.jsx";
import formBuilderService from "../../../../../services/web/form-builder-service.js";
import FormRender from "../../components/form-render.jsx";
import projectUtils from "../../../../../utils/project-utils.js";

const FormBuilderPreview = ({formName, headerTemplate, structure, setIsLoading}) => {
    const [state, setState] = useState({})
    const [modalAttaches, setModalAttaches] = useState({open: false, file: undefined, structureId: undefined})

    useEffect(() => {
        if (!structure.length) {
            setState({})
            return
        }

        setState(prev => {
            const newPrev = {}
            structure.forEach(({type, id}) => {
                if (type !== "subtitle" && type !== "title") {
                    newPrev[id] = prev[id] || null
                }
            })

            return newPrev;
        })
    }, [structure])

    const removeFile = (file) => {
        setState(prev => ({...prev, [file.targetId]: null}))
        closeModalAttaches()
    }

    const openModalAttach = (e, file, id) => {
        e.preventDefault()

        setModalAttaches({open: true, file, structureId: id})
    }

    const closeModalAttaches = () => {
        setModalAttaches({open: false, file: undefined, structureId: undefined})
    }

    const preview = (e) => {
        e.preventDefault()

        const payload = {...state}

        structure.filter(structure => structure.type === "agentSignature").forEach(({id}) => payload[id] = payload[id]?.attachId || null)

        const formData = new FormData()
        formData.append("name", formName)
        formData.append("structure", JSON.stringify(structure))
        formData.append("payload", JSON.stringify(payload))
        formData.append("headerTemplateId", headerTemplate.value)

        const fileEl = structure.filter(structure => structure.type === "file")
        fileEl.forEach(({id}) => {
            const file = payload[id]

            if (file) formData.append("files", file, id)
            delete payload[id]
        })

        structure.filter(item => item.type === "image" && item.file).forEach((item) => formData.append("files", item.file.file, item.id));

        setIsLoading(true)

        formBuilderService.preview(formData)
            .then((data) => {
                const url = URL.createObjectURL(data)
                window.open(url)
            })
            .catch((error) => {
                console.error(error)

                let message = "Não foi possível gerar o preview."
                projectUtils.swalErrorMessage('', message, 'Ok')
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <>
            <div className="col-span-5">
                <Card>
                    <Card.Header className={"!justify-center bg-white"}>
                        <Card.Title className="!text-[16px] bg-white">Preview</Card.Title>
                    </Card.Header>
                    <Card.Body className="overflow-auto space-y-4 h-[calc(100vh-223px)]">
                        <FormRender structure={structure} state={state} setState={setState} openModalAttach={openModalAttach}/>
                    </Card.Body>
                    <Card.Footer className="p-1 bg-white">
                        <Button target="primary" className={"w-full"} onClick={preview}>
                            Gerar PDF
                        </Button>
                    </Card.Footer>
                </Card>
            </div>

            <ModalAttaches
                open={modalAttaches.open}
                setOpen={(value) => setModalAttaches(prev => ({...prev, open: value}))}
                file={modalAttaches.file}
                removeFile={removeFile}
            />
        </>
    )
}

export default FormBuilderPreview